////////////////////////////////////////////////////////////
//  Program: RoomsList.jsx                                //
//  Application:  Rooms                                   //
//  Option: For add or update Tower                       //
//  Developer: kiran singh                                //
//  Date: 2022-03-22                                      //
////////////////////////////////////////////////////////////

import React, { Component } from "react";
import ReactDatatable from "@ashvin27/react-datatable";
import SimpleReactValidator from "simple-react-validator";
import RoomService from "../../services/RoomService";
import { Link } from "react-router-dom";
import { Modal, Form } from "react-bootstrap";
import Alerts from "../common/Alerts";
import FloorService from "../../services/FloorService";
import Select from "react-select";
import BuildingService from "../../services/BuildingService";
import pluswIcon from "./../../assets/images/plus.svg";
import deleteicon from "../../assets/images/delete-gray.svg";
export class Rooms extends Component {
  constructor(props) {
    super(props);

    this.validator = new SimpleReactValidator({ autoForceUpdate: this });

    this.state = {
      is_inactive: false,
      tableQueryString: "",
      customQueryString: "",
      showFilter: global.showFilter,
      input: {},
      errors: {},
      showAlertModal: false,
      alertModalType: "",
      alertModalTitle: "",
      alertModalMessage: "",
      tableName: "property_rooms",
      filter_value: "",
      loading: false,
      isDelete: false,
      total_record: 0,
      property_slug: this.props.propertySlug,
      pathname: window.location.origin,
      sort_order: "",
      floorList: [],
      records: [],
      status_id: true,
      config: {
        sort: {
          column: "room_name",
          order: "asc",
        },
        key_column: "slug",
        page_size: global.page_size,
        length_menu: global.page_length_menu,
        show_length_menu: true,
        show_filter: global.show_filter,
        show_pagination: global.show_pagination,
        pagination: "advance",
        button: {
          excel: global.excel_button,
          print: global.print_button,
          extra: false,
        },
        language: {
          no_data_text: "No record found",
          filter: "Search by room",
        },
      },

      extraButtons: [],
      columns: [
        {
          key: "room_name",
          text: "Room",
          className: "room_name hand-cursor",
          sortable: true,
          cell: (record) => {
            return record.room_name ? record.room_name : "";
          },
        },
        {
          key: "building_id",
          text: "Building",
          className: "building_name hand-cursor",
          sortable: true,
          cell: (record) => {
            // return record && record.building ? record.building.building_name :"";
            return record && record.building_name ? record.building_name : "";
          },
        },
        {
          key: "floor_id",
          text: "Floor ",
          className: "floor_name hand-cursor",
          sortable: true,
          cell: (record) => {
            //return record && record.floor ? record.floor.floor_name :"";
            return record && record.floor_name ? record.floor_name : "";
          },
        },
        {
          key: "sort_order",
          text: "Sort Order",
          className: "room_name hand-cursor",
          sortable: true,
          cell: (record) => {
            return record.sort_order ? record.sort_order : "";
          },
        },
        {
          key: "3",
          text: "Status",
          className: "status_id hand-cursor",
          sortable: false,
          cell: (record) => {
            return record.status_id === 1 ? (
              <b className="status-active">Active</b>
            ) : (
              <b className="status-inactive">Inactive</b>
            );
          },
        },
      ],
      lastQueryString: "",
      tableChangequeryString : "",
      formValues: [{ room_name: "", sort_order: "" }],
      addModalUpdate: false,
    };

    this.closeModal = this.closeModal.bind(this);
    this.resetDate = this.resetDate.bind(this);
    this.openModal = this.openModal.bind(this);
    this.openModalUpdate = this.openModalUpdate.bind(this);
    this.opendeleteModal = this.opendeleteModal.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.filterToggle = this.filterToggle.bind(this);
    this.saveOrUpdateRoom = this.saveOrUpdateRoom.bind(this);
    this.UpdateRoomData = this.UpdateRoomData.bind(this);
  }
  async componentDidMount() {
    this.getFloorData();
    this.getData();
    this.getBuildingData();
    this.setState({
      loading: true,
    });
    if (this.state.slug !== undefined) {
      var resData = {};
      var resDatalist = {};
      let res = await RoomService.getRoomBySlug(this.state.slug);
      if (global.successStatus.includes(res.status)) {
        resData = res.data ? res.data : {};
        resDatalist = resData.data ? resData.data : {};
        resData.room_name = resDatalist.room_name ? resDatalist.room_name : "";
        resData.floor_slug = resDatalist.floor ? resDatalist.floor.slug : "";
        resData.floor_id = resDatalist.floor ? resDatalist.floor.slug : "";
        resData.status_id = resDatalist.status_id === 1 ? true : false;
        resData.sort_order = resDatalist.sort_order
          ? resDatalist.sort_order
          : "";
      }
      this.setState(resData);
      this.defaultData = resData;
    }
    this.setState({
      loading: false,
    });
  }
  async getBuildingData(queryString = "") {
    var buildingList = [];
    var buildingListData = [];
    let res = await BuildingService.getBuilding(
      "is_dropdown=1" +
        "&property_slug=" +
        this.state.property_slug +
        "&" +
        queryString
    );
    if (global.successStatus.includes(res.status)) {
      buildingList = res.data ? res.data : [];
    }
    if (buildingList.length > 0) {
      buildingList.forEach((item) => {
        buildingListData.push({
          label: item.building_name,
          value: item.slug,
        });
      });
    }
    this.setState({
      showSpinner: false,
      buildingList: buildingListData,
    });
  }
  async getMaxorder(table, floorSlug) {
    let sort_order = "";
    let res = await RoomService.getSortOrder(table, floorSlug);
    if (global.successStatus.includes(res.status)) {
      sort_order =
        res.data && res.data.max_order ? res.data.max_order[0].max_order : "";
    }
    this.setState({ sort_order: sort_order });
  }
  async getData(queryString = "") {
    this.setState({ loading: true });
    var list = [];
    var totalRecords = 0;
    let res = await RoomService.getRoom(
      "property_slug=" + this.state.property_slug + "&" + queryString
    );
    if (global.successStatus.includes(res.status)) {
      list = res.data.data ? res.data.data : [];
      totalRecords = res.data ? res.data.total : "";
    }
    this.setState({
      loading: false,
      total_record: totalRecords,
      records: list,
    });
  }
  // FLOOR Change Handler
  handleChangeFloor(value) {
    let floor_slug = [];
    if (value != null && value.length > 0) {
      value.forEach((item, i) => {
        floor_slug.push(item.value);
      });
    }
    this.setState(
      {
        selectedFloor: value,
        floor_slug: value.value,
      },
      () => this.getMaxorder(this.state.tableName, this.state.floor_slug)
    );
  }
  openModal(data) {
    this.getBuildingData();
    this.getFloorData();
    if (data.sort_order === 0) {
      if (data.building !== undefined && data.slug != undefined) {
        this.getMaxorder(this.state.tableName, data.building_slug);
      }
    }
    var selectedBuilding = [];
    selectedBuilding = data
      ? [
          {
            value: data.building_slug,
            label: data.building_name,
          },
        ]
      : "";
    if (data.sort_order === 0) {
      if (data.floor !== undefined && data.slug != undefined) {
        this.getMaxorder(this.state.tableName, data.floor_slug);
      }
    }
    var selectedFloor = [];
    selectedFloor = data
      ? [
          {
            value: data.floor_slug,
            label: data.floor_name,
          },
        ]
      : "";
    this.setState({
      addModal: true,
      showAlertModal: false,
      slug: data.slug,
      room_name: data.room_name,
      selectedFloor: selectedFloor,
      building_slug: data.building_slug ? data.building_slug : "",
      floor_slug: data.floor_slug ? data.floor_slug : "",
      sort_order: data.sort_order ? data.sort_order : "",
      selectedBuilding: selectedBuilding,
      errors: {},
    });

    if (data.slug == undefined) {
      this.setState({ floor_slug: "" });
    }
    if (data.status_id !== undefined) {
      this.setState({ status_id: data.status_id === 1 ? true : false });
    }
  }
  customFilter() {
    let queryString = "filter_value" + this.state.filter_value + "&is_custom=1";
    this.setState({ lastQueryString: queryString });
    this.setState({ tableQueryString: "", customQueryString: queryString });
    this.getData(queryString);
  }

  resetDate() {
    this.setState({ start_date: "", end_date: "", lastQueryString: "" });
    this.getData();
  }

  filterToggle = () => {
    if (this.state.showFilter === 1) {
      this.setState({ showFilter: 0 });
    } else {
      this.setState({ showFilter: 1 });
      document.body.classList.add("bdy_over");
    }
  };

  closeModal() {
    this.setState({ addModal: false, room_name: "" });
    this.validator.hideMessages();
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
  }

  opendeleteModal(slug) {
    this.setState({ addModal: false });
    this.setState({ deleteModal: true, slug: slug });
  }

  closedeleteModal() {
    this.setState({ deleteModal: false });
  }
  changeHandler = (event) => {
    let input = this.state.input;
    let value = event.target.value;
    input[event.target.name] = value;
    this.setState({ [event.target.name]: value, input: input });
    this.validator.showMessageFor(event.target.name);
    this.customValidate();
  };

  tableChangeHandler = (data) => {
  
    // Function to create query parameters
    const createQueryParams = (data) => {
      const params = new URLSearchParams();
      Object.keys(data).forEach((key) => {
        if (key === "sort_order" && data[key]) {
          params.append("sort_order", data[key].order);
          params.append("sort_column", data[key].column);
        } else {
          let newKey = key;
          if (key === "page_number") {
            newKey = "page";
          } else if (key === "sort_order") {
            data[key] = "asc";
          }
          params.append(newKey, data[key]);
        }
      });
      
      return params.toString();
    };
    
    const pageSize = Number(data.page_size);
    const validPageSizes = [10,20, 50, 100];

    let possible = this.state.total_record / pageSize + (this.state.total_record % pageSize ? 1 : 0);
    
    if (data.page_number > possible || ( pageSize && !validPageSizes.includes(pageSize))) {
      data.page_number = 1; 
    }

    const pageSize1 = !isNaN(Number(data.page_size)) ? Number(data.page_size) : 10;
    const pageNumber1 = !isNaN(Number(data.page_number)) ? Number(data.page_number) : 1;

    let queryString = createQueryParams({...data, page_size: pageSize1, page_number: pageNumber1});
  
    if (data.filter_value === "") {
      queryString += `&${this.state.customQueryString}`;
    }
  
    this.setState({ tableQueryString: queryString });
  
    if (data.filter_value !== this.state.filter_value) {  
      clearTimeout(this.state.filter_time);
      this.setState({
        filter_time: setTimeout(
          () => this.getData(queryString),
          global.filter_time
        ),
        filter_value: data.filter_value,
      });
    } else {
      if (this.state.firstLoad === true) {
        queryString = new URLSearchParams({
          page: data.page_number ? data.page_number : 1,
          page_size: data.page_size,
          sort_order: data.sort_order.order,
          sort_column: data.sort_order.column,
        }).toString();
      }
      this.getData(`${queryString}${this.state.lastQueryString}`);
    }
  };

  // BUILDING Change Handler
  handleChangeBuilding(value) {
    let building_slug = [];
    if (value != null && value.length > 0) {
      value.forEach((item, i) => {
        building_slug.push(item.value);
      });
    }
    this.setState(
      {
        selectedBuilding: value,
        building_slug: value.value,
      },
      () => this.getMaxorder(this.state.tableName, this.state.building_slug)
    );
  }
  customValidate() {
    let isValid = true;
    return isValid;
  }
  async deleteRoom(slug) {
    this.setState({ loading: true, isDelete: true });
    let res = await RoomService.deleteRoom(slug);
    if (global.successStatus.includes(res.status)) {
      this.closedeleteModal();
      this.closeModal();
      this.setState({
        showAlertModal: true,
        alertModalType: "success",
        alertModalTitle: "Success",
        alertModalMessage: res.message ? res.message : "Success",
      });
      this.getData();
    } else {
      this.closedeleteModal();
      let alertMessage = "";
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: res.data.message ? res.data.message : "Error!",
        alertModalMessage:
          alertMessage !== "" ? alertMessage : res.data.message,
      });
    }
    this.setState({ loading: false, isDelete: false });
    setTimeout(
      () => this.setState({ showAlertModal: false }),
      global.alert_close_time
    );
  }
  saveOrUpdateRoom = async (e) => {
    e.preventDefault();
    if (this.validator.allValid() && this.customValidate()) {
      this.setState({ isSubmit: true });
      let inputData = {
        property_slug: this.state.property_slug ? this.state.property_slug : "",
        building_slug: this.state.building_slug ? this.state.building_slug : "",
        floor_slug: this.state.floor_slug ? this.state.floor_slug : "",
        formValues: this.state.formValues ? this.state.formValues : "",
        status_id: this.state.status_id === true ? 1 : 2,
      };
      let res = await RoomService.createRoom(inputData);
      if (global.successStatus.includes(res.status)) {
        this.setState({ formValues: [{ room_name: "", sort_order: "" }] });
        this.closeModal();
        this.setState({
          showAlertModal: true,
          alertModalType: "success",
          alertModalTitle: "Success",
          alertModalMessage: res.message ? res.message : "Success",
        });
        let queryString = this.state.tableChangequeryString;
        let params = new URLSearchParams(queryString);
        let currentPageSize = parseInt(params.get('page_size'), 10);
        let newPageSize = currentPageSize + 1;
        let pageNumber = parseInt(params.get('page_number'), 10);
        let newPageNumber = parseInt(pageNumber, 10);
        // params.set('page_size', newPageSize);
        // params.set('page_number', newPageNumber);
        // let updatedQueryString = params.toString();
        // this.getData(updatedQueryString ? updatedQueryString : "");


        this.tableChangeHandler({
          filter_value: this.state.filter_value || "",
          page_number: newPageNumber,  // Always go to the first page after adding a new record
          page_size: newPageSize,
          sort_order: this.state.config.sort || { order: "asc", column: "room_name" },
        });
      } else {
        if (res.data.result.errorDetail) {
          let errors = {};
          res.data.errorCode = "Validation Failed";
          res.data.result.errorDetail.forEach((item) => {
            errors[item.errorField] = item.errorMessage[0];
            res.data.errorMessage = "";
          });
          this.setState({ errors: errors });
        }
        this.setState({
          alertModalMessage: res.data.message ? res.data.message : "Error!",
        });
      }

      this.setState({
        isSubmit: false,
      });
      setTimeout(
        () => this.setState({ showAlertModal: false }),
        global.alert_close_time
      );
    } else {
      this.validator.showMessages();
    }
  };
  async getFloorData(queryString = "") {
    var floorList = [];
    var floorListData = [];
    let res = await FloorService.getFloor(
      "is_dropdown=1" +
        "&property_slug=" +
        this.state.property_slug +
        "&" +
        queryString
    );
    if (global.successStatus.includes(res.status)) {
      floorList = res.data ? res.data : [];
    }
    if (floorList.length > 0) {
      floorList.forEach((item) => {
        floorListData.push({
          label: item.floor_name,
          value: item.slug,
        });
      });
    }
    this.setState({
      floorList: floorListData,
    });
  }
  addFormFields() {
    this.setState({
      formValues: [...this.state.formValues, { room_name: "", sort_order: "" }],
    });
  }
  removeFormFields(i) {
    let formValues = this.state.formValues;
    formValues.splice(i, 1);
    this.setState({ formValues });
  }
  handleChange(i, e) {
    let formValues = this.state.formValues;
    formValues[i][e.target.name] = e.target.value;
    this.setState({ formValues });
  }
  rowClickedHandler = (event, data, rowIndex) => {
    this.openModalUpdate(data);
  };
  openModalUpdate(data) {
    var selectedBuilding = [];
    selectedBuilding = data
      ? [
          {
            value: data.building_slug,
            label: data.building_name,
          },
        ]
      : "";
    var selectedFloor = [];
    selectedFloor = data
      ? [
          {
            value: data.floor_slug,
            label: data.floor_name,
          },
        ]
      : "";
    this.setState({
      addModalUpdate: true,
      showAlertModal: false,
      slug: data.slug,
      room_name: data.room_name,
      selectedFloor: selectedFloor,
      building_slug: data.building_slug ? data.building_slug : "",
      floor_slug: data.floor_slug ? data.floor_slug : "",
      sort_order: data.sort_order ? data.sort_order : "",
      selectedBuilding: selectedBuilding,
      errors: {},
    });
    if (data.status_id !== undefined) {
      this.setState(
        { status_id: data.status_id === 1 ? true : false },
        () => {}
      );
    }
  }
  closeModalUpdate() {
    this.setState({ addModalUpdate: false });
  }
  UpdateRoomData = async (e) => {
    e.preventDefault();
    if (this.validator.allValid() && this.customValidate()) {
      this.setState({ isSubmit: true });
      let inputData = {
        property_slug: this.state.property_slug ? this.state.property_slug : "",
        building_slug: this.state.building_slug ? this.state.building_slug : "",
        floor_slug: this.state.floor_slug ? this.state.floor_slug : "",
        room_name: this.state.room_name ? this.state.room_name : "",
        sort_order: this.state.sort_order ? this.state.sort_order : "",
        status_id: this.state.status_id === true ? 1 : 2,
      };

      if (this.state.slug !== undefined) {
        inputData.status_id = this.state.status_id ? this.state.status_id : 2;
        let res = await RoomService.updateRoom(this.state.slug, inputData);
        if (global.successStatus.includes(res.status)) {
          this.closeModalUpdate();
          this.setState({
            showAlertModal: true,
            alertModalType: "success",
            alertModalTitle: "Success",
            alertModalMessage: res.message ? res.message : "Success",
          });
          this.getData(this.state.is_filter_apply);
        } else {
          //let alertMessage = "";
          if (res.data.result.errorDetail !== null) {
            let errors = {};
            res.data.errorCode = "Validation Failed";
            res.data.result.errorDetail.forEach((item) => {
              errors[item.errorField] = item.errorMessage[0];
              res.data.errorMessage = "";
            });
            this.setState({ errors: errors });
          }
        }
      }
      this.setState({
        isSubmit: false,
      });
      setTimeout(
        () => this.setState({ showAlertModal: false }),
        global.alert_close_time
      );
    } else {
      this.validator.showMessages();
    }
  };
  render() {
    const customStyles = {
      option: (provided, state) => ({
        ...provided,
        color:
          state.isSelected && state.isFocused
            ? "white"
            : state.isSelected
            ? "black"
            : state.isFocused && "white",
        backgroundColor:
          state.isSelected && state.isFocused
            ? "gray"
            : state.isFocused && "gray",
        fontFamily: "Roboto-Regular",
        fontSize: "16px",
      }),
    };
    return (
      <main className="p-0">
        <div
          className={`${
            global.userPermissions.checkPermission(
              "property-update-assigned-property"
            )
              ? "btnNavigate d-flex flex-column building-btn"
              : "d-none"
          }`}
        >
          {global.userPermissions.checkPermission(
            "property-update-assigned-property"
          ) && (
            // {global.userData.role_id === 1 || global.userData.role_id === 6 || global.userData.role_id ===  3 ?
            <>
              {" "}
              <Link to={"#"} className="w-100 d-flex justify-content-end">
                <button
                  className="gf-primary-btn-small-one "
                  onClick={this.openModal}
                >
                  Add Room
                </button>
              </Link>
            </>
          )}
        </div>
        <div className="col-md-12 pl-0 pr-0">
          <Alerts
            show={this.state.showAlertModal}
            type={this.state.alertModalType}
            title={this.state.alertModalTitle}
            message={this.state.alertModalMessage}
          />
        </div>
        <div className="d-flex flex-column">
          <div className="row row-xs mg-t-0 pd-t-0">
            <div className="col-md-12 ">
              <div className="dashboardRightcard mt-top-7neg">
                <div className="mg-t-18 brandList">
                  <ReactDatatable
                    className="table no-wrap mg-b-30 pd-b-2"
                    config={this.state.config}
                    records={this.state.records}
                    columns={this.state.columns}
                    extraButtons={this.state.extraButtons}
                    dynamic={true}
                    loading={this.state.loading}
                    total_record={this.state.total_record}
                    onChange={this.tableChangeHandler}
                    onRowClicked={
                      global.userPermissions.checkPermission(
                        "property-update-assigned-property"
                      ) && this.rowClickedHandler
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="ht-50"></div>
        </div>
        {/* add Floor popup modal */}
        <Modal show={this.state.addModal} centered className="room_popup_modal">
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span className="welcomeClose" onClick={() => this.closeModal()}>
              {global.closee}
            </span>

            <h3 className="text-center">
              {this.state.slug !== undefined ? "Update Room" : "Add Room"}
            </h3>
            <label>Building</label>
            <Select
              className="multiselect new_drop"
              menuPlacement="auto"
              value={this.state.selectedBuilding}
              options={this.state.buildingList}
              isSearchable={true}
              onChange={(value) => this.handleChangeBuilding(value)}
              defaultValue={this.state.selectedBuilding}
              autoComplete="off"
              getOptionValue={(option) => `${option.label}`}
              styles={customStyles}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary75: "#808080",
                  primary50: "#808080",
                  primary25: "#808080",
                },
              })}
            />
            {this.state.errors.building_slug ? (
              <div className="text-danger">
                {this.state.errors.building_slug}
              </div>
            ) : (
              this.validator.message(
                "Building",
                this.state.building_slug,
                "required",
                { className: "text-danger" }
              )
            )}

            <label className="form-label text-left mg-b-0 mg-t-15">Floor</label>
            <Select
              className="multiselect new_drop"
              menuPlacement="auto"
              value={this.state.selectedFloor}
              options={this.state.floorList}
              isSearchable={true}
              onChange={(value) => this.handleChangeFloor(value)}
              defaultValue={this.state.selectedFloor}
              autoComplete="off"
              getOptionValue={(option) => `${option.label}`}
              styles={customStyles}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary75: "#808080",
                  primary50: "#808080",
                  primary25: "#808080",
                },
              })}
            />
            {this.state.errors.floor_slug ? (
              <div className="text-danger">{this.state.errors.floor_slug}</div>
            ) : (
              this.validator.message(
                "Floor",
                this.state.floor_slug,
                "required",
                { className: "text-danger" }
              )
            )}

            {this.state.formValues.map((element, index) => (
              <div className="row" key={index}>
                <div className="col-md-7">
                  <label className="form-label text-left mg-b-0 mg-t-15">
                    Room
                  </label>
                  <Form.Control
                    type="text"
                    onChange={(e) => this.handleChange(index, e)}
                    name="room_name"
                    value={element.room_name !== "" ? element.room_name : ""}
                    maxLength="50"
                    tabIndex="1"
                    className=""
                    autoComplete="off"
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label text-left mg-b-0 mg-t-15">
                    Sort Order
                  </label>
                  <Form.Control
                    onChange={(e) => this.handleChange(index, e)}
                    name="sort_order"
                    className="form-control max_width_100 "
                    value={element.sort_order !== "" ? element.sort_order : ""}
                    type="text"
                    maxLength="50"
                  />
                </div>
                <div className="col-md-2">
                  <div className="room_popup_btn">
                    <button
                      className="button addCat"
                      type="button"
                      onClick={() => this.addFormFields(index)}
                    >
                      <img src={pluswIcon} alt="Add" />{" "}
                    </button>
                    {index != 0 ? (
                      <>
                        <button
                          type="button"
                          className="button remove deleteCat"
                          onClick={() => this.removeFormFields(index)}
                        >
                          <img src={deleteicon} alt="Delete" />
                        </button>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            ))}

            {global.userPermissions.checkPermission(
              "property-update-assigned-property"
            ) && (
              <div className="d-flex align-items-center justify-content-between mg-b-30 pd-b-3 mg-t-15">
                <div className="d-flex">
                  <b
                    className={
                      this.state.status_id == true ? "active" : "inactive"
                    }
                  >
                    {this.state.status_id == true ? "Active" : "Inactive"}
                  </b>

                  <div
                    className={
                      this.state.status_id == true
                        ? "az-toggle on hand-cursor"
                        : "az-toggle hand-cursor"
                    }
                    onClick={() =>
                      this.setState({ status_id: !this.state.status_id })
                    }
                  >
                    <span></span>
                  </div>
                </div>
                {this.state.slug !== undefined ? (
                  //  && (global.userData.role_id === 1 || global.userData.role_id === 6 || global.userData.role_id === 3)
                  <Link
                    onClick={() => {
                      this.opendeleteModal(this.state.slug);
                    }}
                    className="delete-text"
                  >
                    Delete Room
                  </Link>
                ) : (
                  ""
                )}
              </div>
            )}
            <div className="d-flex cnt_center mt-3 row">
              <button
                type="button"
                className="m-0 btn btn-outline-light btn-block"
                onClick={() => this.closeModal()}
              >
                Cancel
              </button>
              {global.userPermissions.checkPermission(
                "property-update-assigned-property"
              ) && (
                <button
                  type="button"
                  className="m-0 btn btn btn-success btn-block"
                  onClick={this.saveOrUpdateRoom}
                  disabled={this.state.isSubmit ? true : false}
                >
                  {this.state.isSubmit
                    ? global.loader
                    : this.state.slug !== undefined
                    ? "UPDATE"
                    : "ADD"}
                </button>
              )}
            </div>
          </Modal.Body>
        </Modal>
        {/* UPDATE floor modal */}
        <Modal show={this.state.addModalUpdate} centered>
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span
              className="welcomeClose"
              onClick={() => this.closeModalUpdate()}
            >
              {global.closee}
            </span>

            <h3 className="text-center">Update Room</h3>
            <label>Building</label>
            <Select
              className="multiselect new_drop"
              menuPlacement="auto"
              value={this.state.selectedBuilding}
              options={this.state.buildingList}
              isSearchable={true}
              onChange={(value) => this.handleChangeBuilding(value)}
              defaultValue={this.state.selectedBuilding}
              autoComplete="off"
              getOptionValue={(option) => `${option.label}`}
              styles={customStyles}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary75: "#808080",
                  primary50: "#808080",
                  primary25: "#808080",
                },
              })}
            />
            {this.state.errors.building_slug ? (
              <div className="text-danger">
                {this.state.errors.building_slug}
              </div>
            ) : (
              this.validator.message(
                "Building",
                this.state.building_slug,
                "required",
                { className: "text-danger" }
              )
            )}

            <label className="form-label text-left mg-b-0 mg-t-15">Floor</label>
            <Select
              className="multiselect new_drop"
              menuPlacement="auto"
              value={this.state.selectedFloor}
              options={this.state.floorList}
              isSearchable={true}
              onChange={(value) => this.handleChangeFloor(value)}
              defaultValue={this.state.selectedFloor}
              autoComplete="off"
              getOptionValue={(option) => `${option.label}`}
              styles={customStyles}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary75: "#808080",
                  primary50: "#808080",
                  primary25: "#808080",
                },
              })}
            />
            {this.state.errors.floor_slug ? (
              <div className="text-danger">{this.state.errors.floor_slug}</div>
            ) : (
              this.validator.message(
                "Floor",
                this.state.floor_slug,
                "required",
                { className: "text-danger" }
              )
            )}

            <div className="row">
              <div className="col-md-7">
                <label className="form-label text-left mg-b-0 mg-t-15">
                  Room
                </label>
                <Form.Control
                  type="text"
                  onChange={this.changeHandler}
                  name="room_name"
                  value={this.state.room_name}
                  maxLength="50"
                  tabIndex="1"
                  className=""
                  autoComplete="off"
                />
              </div>
              <div className="col-md-3">
                <label className="form-label text-left mg-b-0 mg-t-15">
                  Sort Order
                </label>
                <Form.Control
                  onChange={this.changeHandler}
                  name="sort_order"
                  className="form-control max_width_100 "
                  value={this.state.sort_order}
                  type="text"
                  maxLength="50"
                />
              </div>
            </div>

            {global.userPermissions.checkPermission(
              "property-update-assigned-property"
            ) && (
              <div className="d-flex align-items-center justify-content-between mg-b-30 pd-b-3 mg-t-15">
                <div className="d-flex">
                  <b
                    className={
                      this.state.status_id == true ? "active" : "inactive"
                    }
                  >
                    {this.state.status_id == true ? "Active" : "Inactive"}
                  </b>

                  <div
                    className={
                      this.state.status_id == true
                        ? "az-toggle on hand-cursor"
                        : "az-toggle hand-cursor"
                    }
                    onClick={() =>
                      this.setState({ status_id: !this.state.status_id })
                    }
                  >
                    <span></span>
                  </div>
                </div>
                {this.state.slug !== undefined ? (
                  //  && (global.userData.role_id === 1 || global.userData.role_id === 6 || global.userData.role_id === 3)
                  <Link
                    onClick={() => {
                      this.opendeleteModal(this.state.slug);
                    }}
                    className="delete-text"
                  >
                    Delete Room
                  </Link>
                ) : (
                  ""
                )}
              </div>
            )}
            <div className="d-flex cnt_center mt-3 row">
              <button
                type="button"
                className="m-0 btn btn-outline-light btn-block"
                onClick={() => this.closeModalUpdate()}
              >
                Cancel
              </button>
              {global.userPermissions.checkPermission(
                "property-update-assigned-property"
              ) && (
                <button
                  type="button"
                  className="m-0 btn btn btn-success btn-block"
                  onClick={this.UpdateRoomData}
                  disabled={this.state.isSubmit ? true : false}
                >
                  {this.state.isSubmit
                    ? global.loader
                    : this.state.slug !== undefined
                    ? "UPDATE"
                    : "ADD"}
                </button>
              )}
            </div>
          </Modal.Body>
        </Modal>

        {/* add delete modal */}
        <Modal show={this.state.deleteModal} centered>
          <Modal.Body className="width_402 p-4 border_radius_14 h-380">
            <div className="text-center">
              {/* <img src={modaldeleteicon} alt="modal-delete-icon" /> */}
              <h3>Delete Room?</h3>
              <p className="pd-l-50 pd-r-50 pd-b-20 model_first_p">
                Are you sure you want to delete this room? This process cannot
                be reversed
              </p>
              <div className="d-flex cnt_center mt-3 row">
                <button
                  type="button"
                  className="m-0 btn btn-outline-light btn-block"
                  onClick={() => this.closedeleteModal()}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="m-0 btn btn btn-danger btn-block"
                  onClick={() => this.deleteRoom(this.state.slug)}
                  disabled={this.state.isDelete ? true : false}
                >
                  {this.state.isDelete ? global.loader : "Delete"}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </main>
    );
  }
}

export default Rooms;
